/**
 * pano-hero.js
 * Interactive power selector for the hero configurator section.
 * Searches from .pano-hero-section (Shopify section wrapper) to find
 * both the hero area and the configurator card below it.
 */
(function () {
  'use strict';

  // Use event delegation on document to survive Shopify section rendering
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-pano-kw]');
    if (!card) return;

    var grid = card.closest('[data-pano-power-grid]');
    if (!grid) return;

    e.preventDefault();

    // Update selection
    grid.querySelectorAll('[data-pano-kw]').forEach(function (c) {
      c.setAttribute('aria-pressed', 'false');
    });
    card.setAttribute('aria-pressed', 'true');

    var kw = card.dataset.panoKw;

    // Find CTA (may be anywhere in the section, not necessarily in same container)
    var section = card.closest('.pano-hero-section') || document;
    var ctaKw = section.querySelector('[data-pano-cta-kw]');
    var cta = section.querySelector('[data-pano-cta]');

    // Update CTA text
    if (ctaKw) ctaKw.textContent = kw + ' kWc';

    // Update CTA link
    if (cta) {
      var baseUrl = cta.dataset.panoBaseUrl || '/collections/kits-solaires';
      cta.href = baseUrl + '?filter.p.m.specs.puissance=' + kw + 'kwc';

      // Pulse animation
      cta.classList.remove('pano-hero__cta-pulse');
      void cta.offsetWidth;
      cta.classList.add('pano-hero__cta-pulse');
    }
  });

  // Keyboard navigation
  document.addEventListener('keydown', function (e) {
    if (!['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
    var focused = document.activeElement;
    if (!focused || !focused.hasAttribute('data-pano-kw')) return;

    var grid = focused.closest('[data-pano-power-grid]');
    if (!grid) return;

    var cards = Array.from(grid.querySelectorAll('[data-pano-kw]'));
    var idx = cards.indexOf(focused);
    if (idx === -1) return;

    var next = e.key === 'ArrowRight'
      ? (idx + 1) % cards.length
      : (idx - 1 + cards.length) % cards.length;

    cards[next].focus();
    cards[next].click();
    e.preventDefault();
  });
})();
